'use client';

// Route-level error boundary (Next.js App Router convention). If any page
// throws during render, this shows a recoverable message instead of a blank
// white screen — and "Try again" re-renders the segment without a full reload.

import { useEffect } from 'react';

export default function Error({ error, reset }) {
    useEffect(() => {
        // Surface for debugging; never silently swallow.
        console.error('[UI Error]', error);
    }, [error]);

    return (
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <div style={{ maxWidth: 480, textAlign: 'center', background: 'rgba(15,23,42,0.03)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: 16, padding: 28, color: '#334155' }}>
                <div style={{ fontSize: 40, marginBottom: 10 }}>⚠️</div>
                <h2 style={{ fontSize: 20, fontWeight: 800, margin: '0 0 8px' }}>Something went wrong on this screen</h2>
                <p style={{ color: '#475569', fontSize: 14, margin: '0 0 16px' }}>
                    The rest of the app is fine — this page hit an error. You can retry, or head back to the dashboard.
                </p>
                {error?.message && (
                    <pre style={{ textAlign: 'left', fontSize: 11, color: '#dc2626', background: '#f8fafc', padding: 10, borderRadius: 8, overflow: 'auto', maxHeight: 120 }}>
                        {String(error.message).slice(0, 400)}
                    </pre>
                )}
                <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 16 }}>
                    <button onClick={() => reset()} style={{ padding: '10px 18px', background: 'linear-gradient(90deg,#2563eb,#2563eb)', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>Try again</button>
                    <a href="/" style={{ padding: '10px 18px', background: 'rgba(15,23,42,0.04)', color: '#475569', border: '1px solid rgba(15,23,42,0.1)', borderRadius: 10, fontWeight: 700, fontSize: 13, textDecoration: 'none' }}>Go to dashboard</a>
                </div>
            </div>
        </div>
    );
}
